






































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { paymentFields } from '@/config/subscriptions';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import EntityTableInput from '@shared/components/forms/inputs/entity-table-input/entity-table-input.vue';
import EditableInput from '@shared/components/forms/inputs/editable-input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { Payment } from '@accounting/interfaces/payment';
import { Invoice } from '@accounting/interfaces/invoice';
import Time from '@shared/components/forms/inputs/time/time.vue';

@Component({
  name: 'bpc-membership-payment-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-entity-table-input': EntityTableInput,
    'bpc-editable-input': EditableInput,
    'bpc-entity-select': EntitySelect,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-datepicker': Datepicker,
    'bpc-time': Time,
  },
})
export default class MembershipPaymentForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: Partial<Payment>;
  @Prop({ type: Object }) readonly ticket: Partial<Invoice>;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly fetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly edit: boolean;
  @Prop({
    type: Object,
    default() {
      return {
        paid_amount: 0,
        payment_method_type: 'money_transfer',
        payment_date: null,
        payment_time: null,
      };
    },
  })
  readonly value: Partial<Payment>;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;
  @Prop({
    type: String,
  })
  readonly closeButtonsPortalTarget: string;
  @Prop({ type: Number }) readonly membershipId: number;

  // COMPUTED

  get formModel(): Partial<Payment> {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return paymentFields;
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }

  get savePath(): string {
    if (this.formModel?.id) {
      return `${this.$bpcApiRouteHelper.getEntityPath('membership')}/${
        this.membershipId
      }/payments/${this.formModel.id}`;
    }
    return `${this.$bpcApiRouteHelper.getEntityPath('payment')}`;
  }

  // LIFECYCLE
  // created(){}
  // updated(){}
  // destroyed(){}
  mounted() {
    if (!this.edit) {
      this.formModel.paid_amount = this.ticket.balance;
      this.formModel.payment_method_type = 'money_transfer';
      this.formModel.payment_date = this.$bpcHelper.getDateDbStr();
      this.formModel.payment_time = this.$bpcHelper.getTimeDbStr();
    }
  }

  // METHODS
  prepareToSave(formModel: Partial<Payment>) {
    return {
      id: formModel.id,
      paid_amount: formModel.paid_amount,
      payment_method_type: formModel.payment_method_type,
      invoice_id: this.ticket.id,
      contact_id: this.ticket.contact_id,
      payment_date: formModel.payment_date,
      payment_time: formModel.payment_time,
      status: 'paid',
      manual: true,
    };
  }
  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  // WATCHERS
}
